require('./_global.js');
require('./app/search-app');